import { render, staticRenderFns } from "./ClockDial.vue?vue&type=template&id=aff581a4&scoped=true&"
import script from "./ClockDial.vue?vue&type=script&lang=js&"
export * from "./ClockDial.vue?vue&type=script&lang=js&"
import style0 from "./ClockDial.vue?vue&type=style&index=0&id=aff581a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff581a4",
  null
  
)

export default component.exports